(() => {

  const hashLinks = class {

    constructor() {
      this.currentLocationHash = this.getLocationHash();
      this.hashLinks = document.querySelectorAll('a[href*="#"]:not([href="#"])');
  
      this.checkCurrentLocationHash();
  
      if (this.hashLinks.length) {
        this.checkAnchorHashLinks();
      }
      
    }
  
    checkCurrentLocationHash() {
      if (this.hashElementExists(this.currentLocationHash)) {
        setTimeout(() => {
          this.scrollTo(this.getHashElement(this.currentLocationHash));
        }, 100);
      }
    }
  
    checkAnchorHashLinks() {
      this.hashLinks.forEach((a) => {
        if (a.hasAttribute("href")) {
          const hash = a.getAttribute("href").split("#")[1];
          if (this.hashElementExists(hash)) {
            a.addEventListener("click", (e) => {
              e.preventDefault();
              const url = new URL(window.location);
              url.hash = `#${hash}`;
              window.history.pushState({}, "", url);
              this.scrollTo(this.getHashElement(hash));
            });
          }
        }
      });
    }
  
    getLocationHash() {
      return window.location.hash && window.location.hash.includes("#")
        ? window.location.hash.split("#")[1]
        : false;
    }
  
    getHashElement(hash) {
      return document.querySelector(`[data-target-hash-id="${hash}"]`);
    }
  
    hashElementExists(hash) {
      const el = document.querySelector(`[data-target-hash-id="${hash}"]`);
      return el ? el : false;
    }
  
    scrollTo(el) {
      const top = el.offsetTop;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };

  new hashLinks();

})();


